import { getAuth, signOut, onAuthStateChanged, signInWithEmailAndPassword } from "firebase/auth";
import { useState, useEffect } from 'react';
import initializeAuthentication from '../PrivateRoute&init/Firebase.init'

initializeAuthentication();

const useFirebase = () => {
    const [user, setUser] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [authError, setAuthError] = useState('');



    const auth = getAuth();

    const loginUser = (email, password, location, history) => {
        setIsLoading(true);
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const destination = location?.state?.from || '/';
                history.replace(destination)
                setAuthError('');
            })
            .catch((error) => {
                setAuthError(error.message);
            })
            .finally(() => setIsLoading(false));
    }



    // observer user state
    useEffect(() => {
        const unsubscribed = onAuthStateChanged(auth, (user) => {
            if (user) {
                setUser(user);


            } else {
                setUser({})
            }

        });
        return () => unsubscribed;
    }, [auth])



    const logout = () => {

        signOut(auth).then(() => {
            alert('Sign-out successful.')
            setUser({})


        }).catch((error) => {
            // An error happened.
        })

    }



    return {
        user,
        isLoading,
        authError,
        loginUser,
        logout,
    }
}

export default useFirebase;